(function ($, Drupal, drupalSettings) {
  Drupal.behaviors.stickyNavbar = {
    attach: function (context, settings) {
      var $navbar = $(".navbar", context);
      var stickyClass = "fixed-top";
      var shadowClass = "shadow"; // Bootstrap shadow class
      var transitionClass = "navbar-transition"; // Custom transition class
      var hideClass = "navbar-hidden"; // New class for hiding the navbar
      var lastScrollTop = 0; // Track last scroll position

      // Ensure transition class is applied at start
      $navbar.addClass(transitionClass);

      $(window).on("scroll", function () {
        var currentScrollTop = $(this).scrollTop();

        // When scrolled more than threshold, add sticky classes
        if (currentScrollTop > 50) {
          $navbar.addClass(stickyClass).addClass(shadowClass);

          // Determine scroll direction
          if (currentScrollTop > lastScrollTop && currentScrollTop > 150) {
            // Scrolling DOWN and past the initial threshold
            $navbar.addClass(hideClass);
          } else {
            // Scrolling UP
            $navbar.removeClass(hideClass);
          }
        } else {
          // At the top of the page
          $navbar
            .removeClass(stickyClass)
            .removeClass(shadowClass)
            .removeClass(hideClass);
        }

        // Update last scroll position
        lastScrollTop = currentScrollTop;
      });
    },
  };

  Drupal.behaviors.textCounter = {
    attach: function (context, settings) {
      var counterText = $(".counter-text", context);

      if ($(counterText).length) {
        $(counterText).each(function () {
          var $this = $(this);
          var hasAnimated = false; // Prevents multiple animations

          function isInViewport(element) {
            var rect = element.getBoundingClientRect();
            var viewportHeight =
              window.innerHeight || document.documentElement.clientHeight;

            // Check if the element's center is close to the middle of the viewport
            var elementCenter = rect.top + rect.height / 2;
            var viewportCenter = viewportHeight / 2;
            var threshold = viewportHeight * 0.1; // Adjust threshold (10% of viewport height)

            return (
              elementCenter >= viewportCenter - threshold &&
              elementCenter <= viewportCenter + threshold
            );
          }

          function animateCounter() {
            if (hasAnimated) return; // Prevent re-triggering
            if (!isInViewport($this[0])) return; // Ensure it's in the middle

            hasAnimated = true; // Mark as animated

            // Original text (may contain commas, or may not)
            var rawText = $this.text().trim();
            // Check whether the original text has at least one comma
            var hasCommas = rawText.indexOf(",") !== -1;

            // Strip commas to parse the integer
            var numericValue = rawText.replace(/,/g, "");
            var finalVal = parseInt(numericValue, 10) || 0;

            // Start the display at "0"
            $this.text("0");

            // Animate from 0 to finalVal
            $({ currentValue: 0 }).animate(
              { currentValue: finalVal },
              {
                duration: 2000,
                easing: "swing",
                step: function (now) {
                  var displayVal = Math.floor(now).toString();
                  if (hasCommas) {
                    displayVal = Math.floor(now).toLocaleString();
                  }
                  $this.text(displayVal);
                },
                complete: function () {
                  var displayVal = finalVal.toString();
                  if (hasCommas) {
                    displayVal = finalVal.toLocaleString();
                  }
                  $this.text(displayVal);
                },
              }
            );
          }

          // Initial check when the page loads
          animateCounter();

          // Check on scroll
          $(window).on("scroll", function () {
            animateCounter();
          });
        });
      }
    },
  };

  Drupal.behaviors.removeFixedTopIfLoggedIn = {
    attach: function (context) {
      // Check if a user is logged in by verifying user UID exists
      if (
        drupalSettings.user &&
        typeof drupalSettings.user.uid !== "undefined" &&
        drupalSettings.user.uid !== 0
      ) {
        $("nav.navbar", context).removeClass("fixed-top");
      }
    },
  };

  Drupal.behaviors.fadeDownAnimation = {
    attach: function (context, settings) {
      // Check if we're inside the Gutenberg editor and exit early
      if ($("body").hasClass("gutenberg-editor-page")) {
        return;
      }

      let elements = $(".fade-down", context);

      function animateElements() {
        elements.each(function (index) {
          let $el = $(this);
          if (
            $el.offset().top <
            $(window).scrollTop() + $(window).height() - 50
          ) {
            setTimeout(function () {
              $el.addClass("visible");
            }, index * 60); // Delay each element by 100ms
          }
        });
      }

      // Run the function when scrolling or loading
      $(window).on("load scroll", function () {
        animateElements();
      });

      // Trigger animations on AJAX-loaded content
      animateElements();
    },
  };

  Drupal.behaviors.showLetsConnectBlock = {
    attach: function (context, settings) {
      $(window).on("scroll", function () {
        $("#block-skylaraesb5-letsconnect", context).fadeIn(800);
      });
    },
  };

  Drupal.behaviors.randomslideonCarousel = {
    attach: function (context, settings) {
      var $carouselItems = $(".carousel-item", context);
      if ($carouselItems.length > 0) {
        // Remove 'active' class from all items
        $carouselItems.removeClass("active");

        // Select a random item to add 'active' class
        var randomIndex = Math.floor(Math.random() * $carouselItems.length);
        $carouselItems.eq(randomIndex).addClass("active");
      }
    },
  };

  Drupal.behaviors.bsCarouselIndicators = {
    attach: function (context, settings) {
      $(".carousel", context).each(function () {
        var $carousel = $(this);
        var $indicatorsContainer = $carousel.find(".carousel-indicators");

        // Ensure the indicators container exists and is empty
        if (
          $indicatorsContainer.length === 0 ||
          $indicatorsContainer.children().length > 0
        ) {
          return;
        }

        var $slides = $carousel.find(".carousel-inner .carousel-item");

        // Populate indicators
        $slides.each(function (index) {
          var activeClass = index === 0 ? " active" : "";
          var indicator = `<button type="button" data-bs-target="#${$carousel.attr(
            "id"
          )}" data-bs-slide-to="${index}" class="${activeClass}" aria-label="Slide ${
            index + 1
          }"></button>`;
          $indicatorsContainer.append(indicator);
        });
      });
    },
  };

  Drupal.behaviors.searchOverlay = {
    attach: function (context, settings) {
      // Open overlay when clicking the search trigger
      $("#search-trigger", context).on("click", function () {
        $("#search-overlay").fadeIn();
      });

      // Close overlay when clicking the close button
      $(".close-overlay", context).on("click", function () {
        $("#search-overlay").fadeOut();
      });

      // Close overlay when clicking outside of search-overlay-content
      $("#search-overlay", context).on("click", function (event) {
        if (!$(event.target).closest(".search-overlay-content").length) {
          $("#search-overlay").fadeOut();
        }
      });

      // Close overlay when pressing the Escape key
      $(document).on("keydown", function (event) {
        if (event.key === "Escape") {
          $("#search-overlay").fadeOut();
        }
      });
    },
  };

  /* ---------- 1 |  First-level hover behaviour ---------- */
  Drupal.behaviors.bootstrapNavFix = {
    attach(context) {
      const isDesktop = () => window.innerWidth >= 992;

      $(".navbar-nav > .dropdown", context).each(function () {
        const $dd = $(this);
        const $menu = $dd.children(".dropdown-menu");

        $dd.off(".lvl1");

        if (isDesktop()) {
          $dd.on("mouseenter.lvl1", () => {
            $dd.addClass("show active");
            $menu.addClass("show");
          });
          $dd.on("mouseleave.lvl1", () => {
            $dd.removeClass("show active");
            $menu.removeClass("show");
          });
        }
      });

      $(document).on("click.lvl1", (e) => {
        if (!$(e.target).closest(".navbar-nav .dropdown").length) {
          $(".navbar-nav .dropdown, .navbar-nav .dropdown-menu").removeClass(
            "show active"
          );
        }
      });

      $(window).on("resize.lvl1", () =>
        Drupal.behaviors.bootstrapNavFix.attach(context)
      );
    },
  };

  /* ---------- 2 |  Multi-level dropdown (2nd + 3rd tiers) ---------- */
  Drupal.behaviors.multiLevelDropdown = {
    attach(context) {
      const $nav = $(".navbar-nav", context);
      const isDesktop = () => window.innerWidth >= 992;

      $nav.off(".ml"); // clear old handlers

      if (!isDesktop()) return; // mobile handled by Bootstrap

      let hideTimer;

      function show($li) {
        $li
          .addClass("show")
          .children(".dropdown-menu")
          .addClass("show")
          .end()
          .children("a")
          .attr("aria-expanded", "true");

        /* Flip left if it would run off-screen */
        const $menu = $li.children(".dropdown-menu");
        const r = $menu[0].getBoundingClientRect();
        $menu.toggleClass("dropdown-menu-end", r.right > window.innerWidth);
      }

      function hide($li) {
        $li
          .removeClass("show")
          .children(".dropdown-menu")
          .removeClass("show dropdown-menu-end")
          .end()
          .children("a")
          .attr("aria-expanded", "false");
      }

      $nav.on("mouseenter.ml", ".dropdown-submenu", function () {
        clearTimeout(hideTimer);
        show($(this));
      });

      $nav.on("mouseleave.ml", ".dropdown-submenu", function () {
        const $li = $(this);
        hideTimer = setTimeout(() => hide($li), 200); // small grace period
      });

      /* Keyboard arrows ← → */
      $nav.on("keydown.ml", ".dropdown-submenu > a", function (e) {
        if (e.key === "ArrowRight") {
          $(this).parent().trigger("mouseenter");
          $(this).next(".dropdown-menu").find("a").first().focus();
          e.preventDefault();
        } else if (e.key === "ArrowLeft") {
          $(this)
            .closest(".dropdown-menu")
            .closest(".dropdown-submenu")
            .children("a")
            .focus();
          e.preventDefault();
        }
      });

      $(window).on("resize.ml", () =>
        Drupal.behaviors.multiLevelDropdown.attach(context)
      );
    },
  };
  Drupal.behaviors.slickInit = {
    attach: function (context, settings) {
      $(".slick-slider", context)
        .not(".slick-initialized")
        .each(function () {
          let $slider = $(this);
          let $wrapper = $slider.closest(".slick-slider-wrapper");

          // Get basic configuration
          const showArrows =
            $slider.data("arrows") !== undefined
              ? $slider.data("arrows")
              : true;

          let config = {
            autoplay:
              $slider.data("autoplay") !== undefined
                ? $slider.data("autoplay")
                : true,
            autoplaySpeed: $slider.data("autoplay-speed") || 3000,
            arrows: showArrows,
            dots:
              $slider.data("dots") !== undefined ? $slider.data("dots") : true,
            infinite:
              $slider.data("infinite") !== undefined
                ? $slider.data("infinite")
                : true,
            slidesToShow: $slider.data("slides-to-show") || 1,
            slidesToScroll: $slider.data("slides-to-scroll") || 1,
            adaptiveHeight:
              $slider.data("adaptive-height") !== undefined
                ? $slider.data("adaptive-height")
                : true,
          };

          // Only set custom arrows if arrows are enabled
          if (showArrows) {
            config.prevArrow = $wrapper.find(".slick-prev");
            config.nextArrow = $wrapper.find(".slick-next");
          }

          // Set dots class
          config.dotsClass = "slick-dots";

          // Check if responsive settings should be used
          const useResponsive = $slider.data("use-responsive") || false;

          if (useResponsive) {
            const mobileBreakpoint = $slider.data("mobile-breakpoint") || 767;
            const tabletBreakpoint = $slider.data("tablet-breakpoint") || 991;
            const mobileSlides = $slider.data("mobile-slides") || 1;
            const tabletSlides = $slider.data("tablet-slides") || 2;
            const desktopSlides = $slider.data("desktop-slides") || 3;

            // Add responsive configuration
            config.responsive = [
              {
                breakpoint: mobileBreakpoint,
                settings: {
                  slidesToShow: mobileSlides,
                  slidesToScroll: 1,
                },
              },
              {
                breakpoint: tabletBreakpoint,
                settings: {
                  slidesToShow: tabletSlides,
                  slidesToScroll: 1,
                },
              },
              {
                breakpoint: 9999, // Large desktop
                settings: {
                  slidesToShow: desktopSlides,
                  slidesToScroll: 1,
                },
              },
            ];
          }

          try {
            // Ensure visibility after init
            $slider.on("init", function () {
              console.log("Slick Initialized");
              $slider.css("visibility", "visible").css("opacity", "1");
              $(".slick-slide")
                .css("opacity", "1")
                .css("visibility", "visible");
            });

            $slider.slick(config).addClass("slick-initialized");
          } catch (error) {
            console.error("Slick Slider Initialization Error:", error);
          }
        });
    },
  };

  Drupal.behaviors.solutionsCollapsibleScroll = {
    attach: function (context, settings) {
      // Target the solution buttons within the collapsible content block
      $('.aes-solutions-btn[data-bs-toggle="collapse"]', context).each(
        function () {
          // Skip if already processed
          if ($(this).hasClass("scroll-handler-attached")) {
            return;
          }

          // Mark as processed
          $(this).addClass("scroll-handler-attached");

          // Add click handler
          $(this).on("click", function () {
            // Get the target collapse element ID
            const targetId = $(this).data("bs-target");
            const $target = $(targetId);

            // Wait for the collapse animation to complete
            setTimeout(function () {
              // Always account for navbar height regardless of current scroll position
              // This ensures proper offset even when starting from the top of the page
              const $navbar = $(".navbar");
              const navbarHeight = $navbar.outerHeight();

              // Calculate position with offset
              const elementPosition = $target.offset().top;
              const offsetPosition = elementPosition - navbarHeight - 20; // 20px extra padding

              // Scroll to the element
              $("html, body").animate(
                {
                  scrollTop: offsetPosition,
                },
                500
              );
            }, 350); // Slightly longer delay to ensure collapse animation is complete
          });
        }
      );
    },
  };
})(jQuery, Drupal, drupalSettings);
